import React from 'react'
import './reach.css'

const reachData = [
    {
        image: '/images/location.png',
        header: 'OUR LOCATION',
        pText: 'PO Box 16122 Collins StreetWest Victoria 8007',

    },
    {
        image: '/images/phone.png',
        header: 'OUR PHONES',
        pText: '+2348078698593 +2348078698593',

    },
    {
        image: '/images/mail.png',
        header: 'OUR MAIL',
        pText: 'woyetajudeen@gmail.com woyetajudeen@gmail.com',

    }
]

export default function reach() {
  return (
    <div className="reach-wrapper">
     <div className="reach-container">
        <>
           {reachData.map((reach, index) => (  
            <div key={index}>
                <div className='reach-header'>
                    <img src={`${reach.image}`} alt="myImage" className="reach-image" />
                    <h6 className="reach-title">{reach.header}</h6>
                </div>
                <p className="reach-text">{reach.pText}</p>
            </div>
           ))}
        </>
     </div>
    </div>
  )
}
